export default "__VITE_ASSET__3c58dbe1__"